export default __webpack_public_path__ + "static/media/icon-shop.84489456.svg";